import React, { useEffect, useState } from "react";
import socket from "./socket";
import "./styles/SystemRealtimeToast.css";

const CURRENT_VERSION = "wavey-v2";

export default function SystemRealtimeToast() {
    const [toast, setToast] = useState(null);

    useEffect(() => {
        const savedVersion = localStorage.getItem("wavey_app_version");

        if (savedVersion && savedVersion !== CURRENT_VERSION) {
            setToast({
                title: "System Updated",
                message: "Wavey has been updated. Refreshing now...",
                type: "update",
            });

            setTimeout(() => {
                localStorage.setItem("wavey_app_version", CURRENT_VERSION);
                window.location.reload();
            }, 2500);
        } else {
            localStorage.setItem("wavey_app_version", CURRENT_VERSION);
        }

        const playSound = () => {
            const audio = new Audio("/notification.mp3");
            audio.play().catch(() => {
                console.warn("Notification sound blocked until user interacts with page.");
            });
        };

        const showToast = (payload) => {
            setToast(payload);

            if (payload.sound) {
                playSound();
            }

            if (payload.forceRefresh) {
                setTimeout(() => {
                    window.location.reload();
                }, 2500);
            }

            setTimeout(() => {
                setToast(null);
            }, payload.duration || 7000);
        };

        const handleSystemOnline = (data = {}) => {
            console.log("SYSTEM NOTIFICATION RECEIVED:", data);

            showToast({
                title: data.title || "Wavey System Online",
                message: data.message || "System is back online.",
                type: data.type || "online",
                sound: data.sound !== false,
                forceRefresh: Boolean(data.forceRefresh),
                duration: 7000,
            });
        };

        const handleConnect = () => {
            console.log("Socket connected:", socket.id);

            showToast({
                title: "Connected",
                message: "You are connected to Wavey.",
                type: "online",
                sound: false,
                forceRefresh: false,
                duration: 3000,
            });
        };

        const handleDisconnect = (reason) => {
            console.warn("Socket disconnected:", reason);

            setToast({
                title: "Connection Lost",
                message: "Trying to reconnect to Wavey...",
                type: "offline",
            });
        };

        socket.on("system-online", handleSystemOnline);
        socket.on("connect", handleConnect);
        socket.on("disconnect", handleDisconnect);

        return () => {
            socket.off("system-online", handleSystemOnline);
            socket.off("connect", handleConnect);
            socket.off("disconnect", handleDisconnect);
        };
    }, []);

    if (!toast) return null;

    const typeClass =
        toast.type === "offline"
            ? "srt-toast--offline"
            : toast.type === "update"
                ? "srt-toast--update"
                : "srt-toast--online";

    return (
        <div className={`srt-toast ${typeClass}`}>
            <strong className="srt-toast__title">
                {toast.title}
            </strong>
            <span>{toast.message}</span>
        </div>
    );
}